import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body p-10 p-lg-15" }
const _hoisted_3 = { class: "h5 mb-4 word-break_normal" }
const _hoisted_4 = { class: "paragraph" }
const _hoisted_5 = { class: "px-10 py-4 rounded border text-center my-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        border: "",
        data: _ctx.requestedSearchQueryList,
        "scrollbar-always-on": true,
        style: {"width":"100%"},
        "table-layout": "auto",
        "show-header": true,
        resizable: true
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, {
            "image-size": 300,
            description: "Ничего не найдено"
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { label: "Название" }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", {
                class: _normalizeClass(["my-2 flex", _ctx.rowClasses])
              }, [
                _createElementVNode("h4", _hoisted_3, _toDisplayString(scope.row.q), 1)
              ], 2)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { label: "Кол-во запросов" }, {
            default: _withCtx((scope) => [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.rowClasses)
              }, [
                _createElementVNode("p", _hoisted_4, _toDisplayString(scope.row.count), 1)
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.searchQueryLoading]
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_pagination, {
          background: "",
          small: "",
          "page-size": _ctx.filterData.limit,
          "pager-count": 4,
          total: _ctx.paginationItemsNumber,
          "current-page": _ctx.filterData.page,
          layout: "prev, pager, next",
          onCurrentChange: _ctx.paginationClick
        }, null, 8, ["page-size", "total", "current-page", "onCurrentChange"])
      ])
    ])
  ]))
}